export default __webpack_public_path__ + "static/media/wallet.79da78fe.svg";